import { render, staticRenderFns } from "./supervisingDialog.vue?vue&type=template&id=0bd94cba&scoped=true"
import script from "./supervisingDialog.vue?vue&type=script&lang=js"
export * from "./supervisingDialog.vue?vue&type=script&lang=js"
import style0 from "./supervisingDialog.vue?vue&type=style&index=0&id=0bd94cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd94cba",
  null
  
)

export default component.exports